export default __webpack_public_path__ + "static/media/vip.1dac881b.jpg";